import { CommonModule } from '@angular/common';
import { Component, effect, inject, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { customEmailValidator, SiteConfigService } from '~/shared-common';
import { SeoService } from '~/shared-core/utils';
import { environment } from '../../../environments/environment';
import { AuthStore, LocalStorageJwtService } from '../../stores/auth';
import { CompanyWTListStore } from '../../stores/company-wt/company-wt-list.store';
import { LanguagesListStore } from '../../stores/settings/languages-list.store';
import { ThemeService } from '../../stores/themes/theme.service';
@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    ToastModule,
    ReactiveFormsModule,
    RouterModule,
    InputTextModule,
    InputIconModule,
    IconFieldModule,
    ButtonModule,
    DividerModule,
    DropdownModule,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
  providers: [MessageService, ConfirmationService],
})
export class LoginComponent {
  private readonly authStore = inject(AuthStore);
  private fb = inject(FormBuilder);
  private router = inject(Router);
  private localStorageJwtService = inject(LocalStorageJwtService);
  private themeService = inject(ThemeService);
  seoService = inject(SeoService);
  siteConfigService = inject(SiteConfigService);
  companyWTListStore = inject(CompanyWTListStore);
  languagesListStore = inject(LanguagesListStore);
  $loggedIn = this.authStore.loggedIn;
  $companyInfo = this.companyWTListStore.company;
  clientName = 'wt';
  showPass: any = 0;
  showSignUpPass = false;
  signUpSubmitted = false;
  popupForgetPassword: any = 0;
  isResettingPassword = false;
  forgetSubmitted = false;
  popupSignUp = false;
  isSigningUp = false;
  isLoadingLocations = false;
  imgSrcUrl = `${environment.s3_url}/`;
  anvyImage = `/assets/Anvy-logo.png`;
  siteConfig = this.siteConfigService.getSiteConfig();
  logoUrl = this.siteConfig?.system?.logo
    ? [
        environment.s3_url,
        this.siteConfig?.system?.logo?.startsWith('/')
          ? this.siteConfig?.system?.logo
          : `/${this.siteConfig?.system?.logo}`,
      ].join('')
    : null;
  year: number = new Date().getFullYear();
  forgetEmailFormGroup = this.fb.group({
    forget_email: [
      '',
      [
        Validators.required,
        Validators.email,
        customEmailValidator(),
        Validators.maxLength(255),
      ],
    ],
  });
  formGroup = this.fb.group({
    username: ['', [Validators.required, Validators.maxLength(100)]],
    password: ['', [Validators.required, Validators.minLength(3)]],
    direct: 1,
  });
  // defaule_value = `${new Date().getTime()}`;
  defaule_value = ``;
  signUpFormGroup = this.fb.group({
    user_first_name: [
      this.defaule_value,
      [Validators.required, Validators.maxLength(255)],
    ],
    user_last_name: [
      this.defaule_value,
      [Validators.required, Validators.maxLength(255)],
    ],
    user_email: [
      // `${this.defaule_value}@gmail.com`,
      '',
      [
        Validators.required,
        Validators.email,
        customEmailValidator(),
        Validators.maxLength(255),
      ],
    ],
    user_password: [
      this.defaule_value,
      [Validators.required, Validators.minLength(6), Validators.maxLength(30)],
    ],
    cellphone: [
      this.defaule_value,
      [Validators.required, Validators.minLength(3)],
    ],
    default_location_id: [null as number | null, Validators.required],
  });

  $locationList = signal<any[]>([]);

  constructor(private messageService: MessageService) {
    effect(() => {
      const company = this.$companyInfo();
      if (company?.company_name) {
        this.seoService.setTitle(company.company_name);
      }
      if (company?.favicon_file) {
        this.seoService.changeIcon(company.favicon_file, environment.s3_url);
      }
      if (company?.company_id) {
        this.localStorageJwtService.setItemSTR(
          'company_id',
          company.company_id,
        );
        this.localStorageJwtService.setItemSTR(
          'jt_company_id',
          company.jt_company_id ?? '',
        );
      }
      if (company?.theme_css) {
        const companyName = company.company_name || '';
        const themeName = companyName.replace(/\s+/g, '');
        this.themeService.setTheme(themeName, company.theme_css);
      }
    });
    if (this.$loggedIn()) {
      this.router.navigate(['/']);
    }
    this.companyWTListStore.getCompanyInfoByDomain([] as any);
    this.languagesListStore.getListLanguage([] as any);
  }
  login() {
    let { username, password, direct } = this.formGroup.value;
    username = username?.trim().toLowerCase();
    this.authStore.login({
      data: { username, password, direct },
    });
  }

  displayImage(image_file: any) {
    if (!image_file || image_file == '') return '';
    if (image_file[0] == '/') {
      image_file = image_file.substring(1);
    }
    return this.imgSrcUrl + image_file;
  }

  onImageError(event: any) {
    event.target.src = this.anvyImage;
  }
  forgotPassword() {
    this.forgetSubmitted = false;
    this.isResettingPassword = false;
    this.popupForgetPassword = 1;
  }

  closeForgotPassword() {
    this.popupForgetPassword = 0;
    this.forgetSubmitted = false;
    this.isResettingPassword = false;
  }

  onForgetPasswordHide() {
    this.popupForgetPassword = 0;
    this.forgetSubmitted = false;
    this.isResettingPassword = false;
  }
  openSignUp() {
    this.signUpSubmitted = false;
    this.showSignUpPass = false;
    if (!this.$locationList().length) {
      const companyId = Number(
        this.localStorageJwtService.getItemSTR('company_id'),
      );
      this.isLoadingLocations = true;
      this.authStore.getLocationByCompanyId(companyId).subscribe({
        next: (locations) => {
          this.$locationList.set(locations);
          this.isLoadingLocations = false;
          if (
            locations?.length === 1 &&
            !this.signUpFormGroup.value.default_location_id
          ) {
            this.signUpFormGroup.patchValue({
              default_location_id: locations[0].location_id,
            });
          }
        },
        error: () => {
          this.isLoadingLocations = false;
          this.showMessage(
            'Unable to load locations. Please try again.',
            'error',
            'Location error',
          );
        },
      });
    } else if (
      this.$locationList().length === 1 &&
      !this.signUpFormGroup.value.default_location_id
    ) {
      this.signUpFormGroup.patchValue({
        default_location_id: this.$locationList()[0].location_id,
      });
    }
    this.popupSignUp = true;
  }

  closeSignUp() {
    this.popupSignUp = false;
    this.signUpSubmitted = false;
    this.showSignUpPass = false;
  }

  onSignUpHide() {
    this.signUpSubmitted = false;
    this.showSignUpPass = false;
  }

  signUp() {
    this.signUpSubmitted = true;
    if (this.signUpFormGroup.invalid || this.isSigningUp) {
      this.signUpFormGroup.markAllAsTouched();
      return;
    }

    const formValue = this.signUpFormGroup.getRawValue();
    const firstName = formValue.user_first_name?.trim() ?? '';
    const lastName = formValue.user_last_name?.trim() ?? '';
    const email = formValue.user_email?.trim().toLowerCase() ?? '';
    const fullName = firstName + ' ' + lastName;
    const defaultLocationId = Number(formValue.default_location_id);
    const userData = {
      deleted: false,
      from_opm: 0,
      user_first_name: firstName,
      user_last_name: lastName,
      user_name: fullName,
      full_name: fullName,
      user_email: email,
      user_password: formValue.user_password,
      user_phone: formValue.cellphone?.trim(),
      cellphone: formValue.cellphone?.trim(),
      user_type: 3,
      user_status: 0,
      default_location_id: defaultLocationId,
      location_id: [defaultLocationId],
      user_role: [],
      role_content: {},
      use_role_custom: 0,
      newsletter: 0,
      default_user: 0,
    };

    this.isSigningUp = true;
    this.authStore
      .B2BcheckValidEmail({ user_email: email, user_name: fullName })
      .subscribe({
        next: (validResult: any) => {
          if (Number(validResult) !== 1) {
            this.isSigningUp = false;
            this.showMessage(
              'This email is already registered.',
              'error',
              'Sign up failed',
            );
            return;
          }

          this.authStore.registerUserWithoutSendingEmail(userData).subscribe({
            next: (result: any) => {
              if (!result?._id) {
                this.isSigningUp = false;
                this.showMessage(
                  'This email is already registered.',
                  'error',
                  'Sign up failed',
                );
                return;
              }

              this.authStore
                .b2bNoficiationUserSignUp({
                  user_object_id: result._id,
                  company_id: Number(
                    this.localStorageJwtService.getItemSTR('company_id'),
                  ),
                  user_first_name: firstName,
                  user_last_name: lastName,
                  user_email: email,
                  date_created: new Intl.DateTimeFormat('en-US', {
                    month: '2-digit',
                    day: '2-digit',
                    year: 'numeric',
                  }).format(new Date()),
                  from_url: `${window.location.origin}/resources/manage-profile`,
                })
                .subscribe({
                  next: () => this.completeSignUp(),
                  error: () => {
                    this.completeSignUp();
                    this.showMessage(
                      'Your account was created, but the administrator notification could not be sent.',
                      'warn',
                      'Notification failed',
                    );
                  },
                });
            },
            error: () => {
              this.isSigningUp = false;
              this.showMessage(
                'Unable to create your account. Please try again.',
                'error',
                'Sign up failed',
              );
            },
          });
        },
        error: () => {
          this.isSigningUp = false;
          this.showMessage(
            'Unable to validate this email. Please try again.',
            'error',
            'Sign up failed',
          );
        },
      });
  }

  private completeSignUp() {
    this.isSigningUp = false;
    this.popupSignUp = false;
    this.signUpSubmitted = false;
    this.showSignUpPass = false;
    this.signUpFormGroup.reset();
    this.showMessage(
      'Your account is pending. An administrator must approve it before you can log in.',
      'success',
      'Account created',
    );
  }

  resetPassword() {
    this.forgetSubmitted = true;
    if (this.forgetEmailFormGroup.invalid || this.isResettingPassword) {
      this.forgetEmailFormGroup.markAllAsTouched();
      return;
    }
    let { forget_email } = this.forgetEmailFormGroup.value;
    forget_email = forget_email?.trim().toLowerCase();
    this.isResettingPassword = true;
    this.authStore
      .forgetPassword({ user_email: forget_email } as any)
      .subscribe({
        next: (result: any) => {
          this.isResettingPassword = false;
          if (result) {
            this.popupForgetPassword = 0;
            this.forgetSubmitted = false;
            this.forgetEmailFormGroup.reset();
            this.showMessage('Reset password is sent', 'info', 'Confirmed');
          } else {
            this.showMessage('Email is not valid', 'error', 'Confirmed');
          }
        },
        error: () => {
          this.isResettingPassword = false;
          this.showMessage(
            'Unable to send reset password link. Please try again.',
            'error',
            'Confirmed',
          );
        },
      });
  }
  showMessage(message: any, severity: any, label: any) {
    this.messageService.add({
      severity: severity,
      summary: label,
      detail: message,
    });
  }
  callLogin() {
    this.popupForgetPassword = 0;
  }
}
